import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Switch } from '@material-ui/core';
import GeozonesMap from '../Geozone/GeozonesMap';
import { TabbedTables } from '../Geozone/GeozoneDetails';
import {
  HeaderContainer, HeaderTitle, BackButton,
  BounceAnimatedContainer, PaperContainer,
} from '../../healtheraComponents';
import * as actions from '../../redux/geozones';
import { useSelector, useDispatch } from 'react-redux';


const DeliveryGeofenceMap = (props) => {
  const [showPins, setShowPins] = useState(true);
  const dispatch = useDispatch();
  const { deliveryPharmacies: pharmacies } = useSelector(state => state.geozones);

  useEffect(() => {
    dispatch(actions.getDeliveryPharmacyGeofences());
  }, [dispatch]);

  const goBack = () => props.history.push(`${process.env.PUBLIC_URL}/regions`);
  const onClick = id => props.history.push(`${process.env.PUBLIC_URL}/branches/${id}`);

  return (
    <>
      <BounceAnimatedContainer>
        <HeaderContainer padding={`20px 0 20px 0`} onClick={goBack} borderbottom={`none`} p={2} align='center'>
          <BackButton padding={`0 5px 0 0`} />
          <HeaderTitle cursor={`pointer`} px={2} w={1 / 3}>Regions</HeaderTitle>
        </HeaderContainer>
        <PaperContainer elevation={0}>
          <HeaderContainer marginright={`0px`} padding={`0 0 20px 0`}>
            <HeaderTitle fontSize={`24px`}>Referral Pharmacies</HeaderTitle>
          </HeaderContainer>
          <br />
          <GeozonesMap
            pharmacies={pharmacies}
            withMarker={showPins}
            withPaidDeliverySplit={true}
            onClickPolygon={onClick}
            onClickMarker={onClick}
          />
          <br />
          <p style={{ color: '#2f9d6d' }}>Referral Pharmacy</p>
          <p style={{ color: '#294d9d' }}>Paid Delivery Pharmacy</p>
          <br />
          <div>
            Show all the pins
            <Switch
              value={showPins}
              checked={showPins}
              onChange={() => setShowPins(!showPins)}
            />
          </div>
        </PaperContainer>
      </BounceAnimatedContainer>
      <br />
      {pharmacies && <TabbedTables pharmacies={pharmacies}/>}
    </>
  )
};

export default withRouter(DeliveryGeofenceMap);
